import React, {useRef, useState} from 'react'
import {SLowcodeList, STableActions, SActionBtn} from 'shj-components'
import config from './exception.config'
import {Button, message, Popconfirm} from 'antd'
import {getAuth} from '@/utils/btn.ts'

import CheckThePhone from '@/components/CheckThePhone'
import {apiData2Table} from '@/utils/data.ts'
import {
  callReceive,
  dispatchClueAgain,
  getClueDetail,
  getDispatchExceptionPage,
  getDispatchMnrList
} from "@/services/saleOpServices.ts";
import AddNewPlanModal from "@/components/AddNewPlanModal";
import {getBusinessLines, getChannels} from "@/services/getUsers.ts";
import {iiHOC} from "@/utils/auth.ts";
import {httpOrgList} from "@/services/homeService.ts";
import {getAnchorFn} from "@/pages/clueManage/utils.tsx";
import {getRegionLists} from "@/services/customerServices.ts";

function Exception() {
  const listRef = useRef<any>()
  const [loading, setLoading] = useState<boolean>(false)

  const [addRefRecord, setAddRefRecord] = useState<any>(undefined)
  const [open, setOpen] = useState<any>(false)

  const [businessLineMap, setBusinessLineMap] = useState<Record<string, string>>({})

  const getSelection = () => {
    return new Promise(resolve => {
      Promise.all([
        getBusinessLines(),
        getChannels(),
        httpOrgList(),
        getAnchorFn('ADVERT'),
        getRegionLists(),
      ]).then(resp => {
        const businessLines = resp[0]
        const tempBusinessLineMap = {}
        businessLines.forEach(item => {
          tempBusinessLineMap[item.code] = item.name
        })
        setBusinessLineMap(tempBusinessLineMap)
        resolve({
          businessLines,
          channels: resp[1],
          companyList: resp[2],
          anchor: resp[3],
          cityArea: resp[4],
        })
      })
    })
  }

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {current, pageSize, query} = values
        getDispatchExceptionPage({
          params: {pageId: current, pageSize},
          data: {...query, queryBrandFlag: true,}
        })
            .then(data => resolve(apiData2Table(data)))
            .finally(() => {
              setLoading(false)
            })
      } catch {
        reject({success: false})
        setLoading(false)
      }
    })
  }

  const dispatch = ({selectedRowKeys: clueIds}: { selectedRowKeys: number[] }) => {
    setLoading(true)
    message.loading('派单中，请稍后', 0)
    dispatchClueAgain({clueIds}).then((res: any) => {
      message.destroy()
      message.success(res.message || '派单成功')
      listRef.current.reload()
    }).catch((err)=>{
      message.destroy()
      message.error(err.message || '派单失败')
    }).finally(() => setLoading(false))
  }

  const edit = (obj: any) => {
    setOpen(true)
    getClueDetail(obj.id).then(res => {
      console.log(res)
      setAddRefRecord(res)
    })
  }

  // 刷新
  const reloadFn = () => {
    listRef.current?.reload?.()
  }

  // 领取线索
  const getClue = (id: any) => {
    message.loading('领取中，请稍后', 0)
    callReceive(id).then((res: any) => {
      message.destroy()
      message.success(res.message || '领取成功')
      listRef.current.reload()
    }).catch((err)=>{
      message.destroy()
      message.error(err.message || '领取失败')
    }).finally(() => setLoading(false))
  }

  const filterOption = (input: string, option: any) =>
      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

  const extension = {
    request: {fetchList, getSelection},
    events: {filterOption},
    auth: getAuth(),
    customRender: {
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="errorListViewPhone"/>
        )
      },
      businessLineRender(val: string) {
        return businessLineMap && businessLineMap[val] ? businessLineMap[val] : val
      },
      dispatch(record: any) {
        // const isBtnObj = processButtonData({ arr: authArr, stateCode: record?.stateCode });
        return iiHOC(
            <Popconfirm
                disabled={loading}
                title="确认继续派单吗？"
                onConfirm={() => dispatch(record)}
            >
              {/*auth: 'exceptionContinueBtn',*/}
              <Button datareskey={'exceptionContinueBtn'} disabled={loading||(record?.selectedRowKeys?.length<=0)} type="primary">
                继续派单
              </Button>
            </Popconfirm>
        )
      },

      operationCell(text: any, record: any) {
        return (
            <STableActions>
              <SActionBtn
                  onClick={() => {
                    edit({...record, exception: true})
                  }}
                  auth={'salesWorkBenchClueInfoEdit'}
                  // datareskey="EditBizDetailButton"
              >
                编辑
              </SActionBtn>
              <SActionBtn
                  onClick={() => {
                    getClue(record.id)
                  }}
                  // datareskey="CallCluePickFromOcean2"
              >
                领取
              </SActionBtn>
            </STableActions>
        )
      },
    },
  }

  return (
      <>
        <SLowcodeList searchMode={'group'} config={{...config}} ref={listRef} {...extension} />
        {open && <AddNewPlanModal basicInfo={addRefRecord || {}}
                                            editReload={() => {
                                              reloadFn()
                                              setOpen(false)
                                              setAddRefRecord({})
                                            }}
                                            reload={() =>{
                                              reloadFn()
                                              setOpen(false)
                                              setAddRefRecord({})
                                            }}
                                            isEdit={true} open={open}
                                            onClose={() => {
                                              setOpen(false)
                                              setAddRefRecord({})
                                            }}
        />}
      </>
  )
}

export default Exception
